import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import ConfigOryaMiniChat from './ConfigOryaMiniChat';
import './ConfigOryaAssistant.css';

const CLOSE_ANIM_MS = 340;
const FAB_BOTTOM_SECTIONS = ['users', 'equipe'];
export const CONFIG_ORYA_OPEN_EVENT = 'config-orya:open';

export function openConfigOryaAssistant() {
  window.dispatchEvent(new CustomEvent(CONFIG_ORYA_OPEN_EVENT));
}

export default function ConfigOryaAssistant({
  userDisplayName = '',
  configSection = 'process',
  submenuId = null,
  hideFab = false,
}) {
  const [chatOpen, setChatOpen] = useState(false);
  const [chatClosing, setChatClosing] = useState(false);

  const openChat = useCallback(() => {
    setChatClosing(false);
    setChatOpen(true);
  }, []);

  const closeChat = useCallback(() => {
    setChatClosing(true);
    window.setTimeout(() => {
      setChatOpen(false);
      setChatClosing(false);
    }, CLOSE_ANIM_MS);
  }, []);

  useEffect(() => {
    const onOpen = () => openChat();
    window.addEventListener(CONFIG_ORYA_OPEN_EVENT, onOpen);
    return () => window.removeEventListener(CONFIG_ORYA_OPEN_EVENT, onOpen);
  }, [openChat]);

  const rootClassName = [
    'config-orya-assistant-root',
    FAB_BOTTOM_SECTIONS.includes(configSection) ? 'config-orya-assistant-root--bottom' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return createPortal(
    <div className={rootClassName} aria-hidden={false}>
      {!hideFab && !chatOpen && (
        <button
          type="button"
          className="config-orya-fab"
          onClick={openChat}
          aria-label="Abrir assistente de IA"
        >
          <span className="config-orya-fab-icon" aria-hidden>
            <span className="config-orya-fab-icon-big" />
            <span className="config-orya-fab-icon-small" />
          </span>
          <span className="config-orya-fab-label">Assistente</span>
        </button>
      )}

      {chatOpen && (
        <ConfigOryaMiniChat
          onClose={closeChat}
          isClosing={chatClosing}
          userDisplayName={userDisplayName}
          configSection={configSection}
          submenuId={submenuId}
        />
      )}
    </div>,
    document.body
  );
}
